export const groupNameMapping: Record<string, string> = {
    "KI - LO Insubot CS": "LOGSTOR",
    "KI - TR Insubot Tech": "Troldtekt",
    "KI - ZZ Insubot Compliance": "Compliance",
    "KI - LO Insubot TS": "LOGSTOR - Technical Solutions",
    "KI - LO Insubot IN": "LOGSTOR Industry",
    "KI - KICE Insubot TSD": "KICE TSD",
    "KI - ZZ Insubot Test": "Test Environment"
};

export const getGroupDisplayName = (backendName: string): string => {
    return groupNameMapping[backendName] || backendName;
};
